<template lang="pug" >
	v-card.style-html()
		v-card-title.no-padding
			v-toolbar(dark='', class='primary',dense)
				v-toolbar-title.white--text {{titulo}}
				
				
		v-card-text.no-padding()
			v-container(grid-list-lg)
				v-layout(row,wrap)
					v-flex.no-padding-vertical(xs12 sm12 md12 lg12 sl12)
						p.white--text(style="font-size:20px") {{descripcion}}
					v-flex.no-padding-vertical(v-if="Array.isArray(listaDescripcion)" xs12 sm12 md12 lg12 sl12)
						p(v-for="(item, index) in listaDescripcion" style="font-size:18px") {{item}}
		v-divider
		v-card-actions
			v-spacer
			v-btn(class="red" style="color:#ffffff !important" @click="onNo") No
			v-btn(
			:loading="loading"
			:disabled="loading"
			
			color="blue-minedu"
			@click.native="onSi" dark) Si
				span(slot="loader" class="custom-loader blue-minedu--text")
					v-icon(color="black") cached			
				
									
</template>
<style>
	.text-normal{
		text-transform: initial;
	}

</style>
<script>
module.exports = {
  props: {
    onNo: {
      type: Function,
      required: true
    },
    onSi: {
      type: Function,
      required: true
    },
    loading: {
      type: Boolean,
      required: true
    },
    titulo: {
      type: String,
      required: true
    },
    descripcion: {
      type: String,
      required: true
    },
    listaDescripcion: {
      type: Array,
      required: false
    }
  },
  mounted: function() {
    return this.$nextTick(function() {});
  }
};
</script>


